/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import iconKeys from '../../constants/icons'

const useStyle = makeStyles(() => ({
  root: {
    fontFamily: 'PictoIcons',
  },
}))

const getIcon = (key) => {
  if (typeof key === 'string' && !!iconKeys[key]) {
    return iconKeys[key]
  }
  return ''
}

const PictoIcon = ({ children, className, ...props }) => {
  const classes = useStyle()

  return (
    <Typography
      gutterBottom={false}
      className={`${classes.root} ${className}`}
      {...props}
    >
      {getIcon(children)}
    </Typography>
  )
}

export default PictoIcon
